//网点完工用户确认异常-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :exceptionOrderDeal="true" :dealType="orderDealType" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="soOrderExport" status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">工单导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;position: relative;">
                  <el-input type="textarea"
                            :autosize="{ minRows: 1, maxRows: 3}" style="width: 200px;     height: 27px !important; " @keyup.enter.native="searchEvent"
                            v-model="formData.orderNoArr" placeholder="请输入工单号或用户联系方式" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                              @click="searchEvent">{{ $t('common.search') }}
                  </vxe-button>
                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;"
                       @click="show3 = !show3">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>{{ $t('common.MoreScreening') }}</span>
                  </div>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form v-show="show3" ref="form" class="screen-box" title-width="7vw" title-align="right"
                          :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData"
                          @reset="searchEvent">
                  <vxe-form-item title="服务完成确认" field="name">
                    <template v-slot>
                      <el-select v-model="formData.custComfirmStat" clearable style="width:9vw ;">
                        <el-option :value="0" label="未确认"></el-option>
                        <el-option :value="1" label="异常确认"></el-option>
                        <el-option :value="2" label="已确认"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="用户确认方式" field="name">
                    <template v-slot>
                      <el-select v-model="formData.custComfirmType" clearable style="width:9vw ;">
                        <el-option :value="1" label="微信确认"></el-option>
                        <el-option :value="2" label="短信确认"></el-option>
                        <el-option :value="3" label="无法确认"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="用户确认结果" field="name">
                    <template v-slot>
                      <el-select v-model="formData.custComfirmResult" clearable style="width:9vw ;">
                        <el-option :value="1" label="服务未完成"></el-option>
                        <el-option :value="2" label="服务确认完成"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="现场人电话" field="name">
                    <template v-slot>
                      <el-input v-model="formData.custComfirmMobile" size="small" style="width:9vw ;" clearable
                                placeholder="姓名或手机号或工号"/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.TimeCompletion')+':'" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.completeDate" type="daterange"
                                      align="right"
                                      unlink-panels range-separator="-"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="异常确认处理" field="name">
                    <template v-slot>
                      <el-select v-model="formData.custComfirmException" clearable style="width:9vw ;">
                        <el-option :value="1" label="待处理"></el-option>
                        <el-option :value="2" label="已处理"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>


                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
<!--                <div v-for="(item, index) in goodsStatusList" :key="index">-->
<!--                  <div :class="{-->
<!--											btnGoodsStatusBt1: goodsStatusIndex == index,-->
<!--											btnGoodsStatusBt: goodsStatusIndex != index-->
<!--										}" @click="changeGoodsStatus(item, index)">-->
<!--                    <span>{{ item.name }}</span> <span v-if="item.name!='所有'" class="num_color">{{ item.num }}</span>-->
<!--                  </div>-->
<!--                </div>-->
              </div>

            </template>

            <template #showSiteComplainStat="{row}">
              <span v-if="row.siteComplainStat == 0">无申诉</span>
              <span v-else-if="row.siteComplainStat == 3">待申诉</span>
              <span v-else-if="row.siteComplainStat == 5">已申诉</span>
              <span v-else-if="row.siteComplainStat == 7">中心已审核</span>
              <span v-else-if="row.siteComplainStat == 8">中心驳回</span>
              <span v-else-if="row.siteComplainStat == 9">总部已处理</span>
              <span v-else-if="row.siteComplainStat == 99">取消</span>
            </template>

            <template #showRecallStat="{row}">
              <span v-if="row.recallStat == 0">未回访</span>
              <span v-else-if="row.recallStat == 1">已抽样</span>
              <span v-else-if="row.recallStat == 2">已回访</span>
              <span v-else-if="row.recallStat == 2">已回访</span>
              <span v-else-if="row.recallStat == 5">用户已评价</span>
            </template>

            <template #showStat="{row}">
              <span v-if="row.stat == 1">登记</span>
              <span v-else-if="row.stat == 2">发布</span>
              <span v-else-if="row.stat == 5">已派网点</span>
              <span v-else-if="row.stat == 6">网点已接单</span>
              <span v-else-if="row.stat == 9">已派师傅</span>
              <span v-else-if="row.stat == 10">师傅已接单</span>
              <span v-else-if="row.stat == 11">已预约</span>
              <span v-else-if="row.stat == 13">已出发</span>
              <span v-else-if="row.stat == 17">已上门</span>
              <span v-else-if="row.stat == 20">完工暂存</span>
              <span v-else-if="row.stat == 30">寄修待确认</span>
              <span v-else-if="row.stat == 31">待寄件</span>
              <span v-else-if="row.stat == 32">已寄待签收</span>
              <span v-else-if="row.stat == 36">待维修</span>
              <span v-else-if="row.stat == 37">修好待寄出</span>
              <span v-else-if="row.stat == 38">客户待签收</span>
              <span v-else-if="row.stat == 40">退换待确认</span>
              <span v-else-if="row.stat == 41">旧机待退回</span>
              <span v-else-if="row.stat == 42">旧机待签收</span>
              <span v-else-if="row.stat == 43">旧机已签收</span>
              <span v-else-if="row.stat == 44">新机待寄出</span>
              <span v-else-if="row.stat == 45">新机已寄出</span>
              <span v-else-if="row.stat == 47">新机待签收</span>
              <span v-else-if="row.stat == 48">新机已签收</span>
              <span v-else-if="row.stat == 49">退换被驳回</span>
              <span v-else-if="row.stat == 61">已完工</span>
              <span v-else-if="row.stat == 62">网点确认完工</span>
              <span v-else-if="row.stat == 63">中心完工审核</span>
              <span v-else-if="row.stat == 64">总部完工审核</span>
              <span v-else-if="row.stat == 91">待结算</span>
              <span v-else-if="row.stat == 92">结算驳回</span>
              <span v-else-if="row.stat == 93">结算中止</span>
              <span v-else-if="row.stat == 94">已结算</span>
              <span v-else-if="row.stat == 97">申请关闭</span>
              <span v-else-if="row.stat == 98">挂起</span>
              <span v-else-if="row.stat == 99">取消</span>
            </template>

            <template #showGuaranteeType="{row}">
              <span v-if="row.guaranteeType == 1">保内</span>
              <span v-else-if="row.guaranteeType == 2">保外</span>
              <span v-else-if="row.guaranteeType == 3">未知</span>
            </template>

            <template #riskTitleNameSlots="{row}">
              <span class="txt-status disable"
                    v-if="row.riskTitleName && row.riskTitleName != '0'">{{ row.riskTitleName }}</span>
              <span v-else></span>
            </template>

            <template #comfirmStatSlot="{row}">
              <span v-if="row.stat == 0">未确认</span>
              <span v-else-if="row.stat == 1">异常确认</span>
              <span v-else-if="row.stat == 5">已确认</span>
            </template>

            <template #comfirmExceptionSlot="{row}">
              <span v-if="row.stat == 1">待处理</span>
              <span v-else-if="row.stat == 2">已处理</span>
            </template>

            <template #comfirmTypeSlot="{row}">
              <span v-if="row.stat == 1">微信确认</span>
              <span v-else-if="row.stat == 2">短信确认</span>
              <span v-else-if="row.stat == 3">无法确认</span>
            </template>

            <template #comfirmResultSlot="{row}">
              <span v-if="row.stat == 1">服务未完成</span>
              <span v-else-if="row.stat == 2">服务确认完成</span>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <template #option="{row}">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)">
                  <el-tooltip  effect="dark" content="查看" placement="top"
                               popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)" >
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item  v-if="exceptionDeal && row.custComfirmException==1" command="1">异常处理</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true"/>


    <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true"/>
    <!-- 列表指派 -->
    <zhiPaiDialog v-if="showAssignDialog" :visiable.sync="showAssignDialog" multi="true" :orderId="orderId" :assginType="assginType"  @commitSiteRow="commitSiteRow"/>
    <mapDialog v-if="showAssignByMapDialog" :visiable.sync="showAssignByMapDialog" multi="true" :param="assignSiteParam" :orderId="orderId" :assginType="assginType" @commitSiteRow="commitSiteRow"/>
    <assignDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect"
                  :visiable.sync="showOrgDialog" multi="true" :orderId="orderId"/>
    <closeOrderDialog  v-if="showCloseOrderDialog" @closeOrderRemark="closeOrderRemark"
                       @closeD="closeD"
                       :visiable.sync="showCloseOrderDialog" multi="true" :orderId="orderId"/>
    <exceptionDealOrder v-if="showExceptionDealDialog" @closeExceptionOrderDeal="closeExceptionOrderDeal"
                 :visiable.sync="showExceptionDealDialog" :param="orderRemarkParam"/>
  </div>
</template>

<script>
import editView from '../common/edit.vue';
import preconditionDialog from '../common/dialog';
import preconditionDialog2 from '../common/dialog2.vue';
import mapDialog from '../common/mapdialog.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
// 列表指派
import zhiPaiDialog from '@/views/dialogCommon/assignSiteDialog.vue';
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import BrandSelect from "@/components/formItem/brandSelect.vue";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import OrderTypeSelect from "@/components/formItem/orderTypeSelect.vue";
import DispatchStatSelect from "@/components/formItem/dispatchStatSelect.vue";

import assignDialog from "@/views/dialogCommon/orgDialog";
import closeOrderDialog from "@/views/dialogCommon/closeOrderDialog.vue";
// 工单跟进
import orderRemark from "@/views/dialogCommon/orderRemarkDialog";
import exceptionDealOrder from "@/views/dialogCommon/exceptionDealOrderDialog.vue";



//取消审核
import cancelCheckDialog from "@/views/dialogCommon/orderCancelCheckDialog"
import store from "@/store";
import {mapState} from 'vuex';
import {siteMixins} from "@/mixins/tabChang";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import BuyChannelSelect from "@/components/formItem/buyChannelSelect.vue";

export default {
  inject: ['reload'],
  mixins: [siteMixins],
  components: {
    BuyChannelSelect,
    DispatchStatSelect,
    OrderTypeSelect,
    ServiceTypeCascader,
    BrandSelect,
    SiteSearch,
    OrgSearch,
    editView,
    pager,
    preconditionDialog,
    preconditionDialog2,
    zhiPaiDialog,
    mapDialog,
    closeOrderDialog,
    orderRemark,
    exceptionDealOrder,
// 修改工单

  },

  data() {
    return {
      total: 0,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      orderDealType:"",
      //权限管理
      assignOrg:false,
      orderEdit:false,
      assignSite:false,
      assignSites:false,
      orderClose :false,
      assignSiteByMap :false,
      orderFollowUp:false,
      orderFinish:false,
      areaObj: null,
      bigCategoryOption: [],
      exceptionDeal:false,
      soOrderExport:false,
      cancelCheck:false,
      assignAgain:false,
      requestParam: {
        isSubordinateWork:2,
        buyChannelId: null,
        bigCategoryId: null,
        profileSearchValue: null,
        userAddress: null,
        engineerValue: null,
        engineerId: null,
        pageType: '异常确认处理',
        areaId: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        stat: null,
        stats:[],
        createTimeBegin: null,
        createTimeEnd: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        searchValue: null,
        orderNoArr: null,
        tabStat: null,

        serviceTypeId: null,
        partsStat: null,
        siteId: null,
        createBy: null,
        bookDateBegin: null,
        bookDateEnd: null,
        orderTypeId: null,
        outOrderNo: null,
        dispatchStat: null,
        dispatchStats:[],
        orgIdPath: null,

        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        resultBarcode: '',//完工条码
        urgeTimesBegin: '',
        urgeTimesEnd: '',
        creationTimeSort: 2,

        managerUserId: null,
        techManager: null,
        custComfirmStat:1,
        custComfirmType:null,
        custComfirmResult:null,
        custComfirmMobile:'',
        custComfirmException:1
      },
      orderRemarkParam:{},
      assignSiteParam:{},
      //批量orderId
      orderIds:[],
      //指派类型0列表指派1批量指派2地图指派3重新指派
      assginType:0,
      //工单跟进抽屉
      showExceptionDealDialog:false,
      completionDialog:false,
      bookDialog:false,
      dispatchEngineerDialog:false,
      dispatchedMasterDialog:false,
      subcontractorDialog:false,
      dispatchedNetworkDialog:false,
      //取消审核抽屉
      showCancelCheckDialog:false,
      isSite:null,
      formData: {
        isSubordinateWork:2,
        buyChannelId: null,
        bigCategoryId: null,
        profileSearchValue: null,
        userAddress: null,
        engineerValue: null,
        engineerId: null,
        areaId: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeDate: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        bookDate: null,
        bookDateBegin: null,
        bookDateEnd: null,
        searchValue: null,
        orderNoArr: null,
        partsStat: null,
        stat: null,
        orderTypeId: null,
        serviceTypeId: null,
        siteId: null,
        createBy: null,
        outOrderNo: null,
        managerName: null,
        siteName: null,
        dispatchStat: null,
        dispatchStats:[],
        orgId: null,
        orgIdPath: null,
        orgName: null,
        resultBarcode: '',//完工条码
        urgeTimesBegin: '',
        urgeTimesEnd: '',
        creationTimeSort: 2,
        stats:[],
        managerUserId: null,
        techManager: null,
        custComfirmStat:1,
        custComfirmType:null,
        custComfirmResult:null,
        custComfirmMobile:'',
        custComfirmException:1
      },
      show3: false,
      enableStat: false,
      sitePromptList: [],

      goodsStatusList: [ //循环列表
        {name: "所有", num: 0},
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,
      showAssignDialog:false,
      showAssignByMapDialog:false,
      showCloseOrderDialog:false,
      orderId:"",
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],

      showEdit: false,
      // 指派中心弹框
      showOrgDialog: false,
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          width: 100,
          field: 'status',
          fixed: 'right',
          title: this.$t('common.Controls'),
          showOverflow: true,
          slots: {default: 'option'}
        },
        {
          title: this.$t('common.WorkOrderNumber'), field: 'orderNo', sortable: true,
          editRender: {name: 'RoleCell', events: {click: this.filterNameMethod}}, width: 182, slots: {
            filter: 'age_filter',
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        {title: this.$t('common.ServiceType'), field: 'serverTypeName', sortable: true, width: 100,},
        {title: this.$t('common.status'), field: 'stat', width: 142, sortable: true, slots: {default: 'showStat'}},
        {title: this.$t('common.SourceWorkOrder'), field: 'orderTypeName', sortable: true, width: 100,},

        {title: '服务完成确认', field: 'custComfirmStat', sortable: true, width: 100,slots: {default: 'comfirmStatSlot'}},
        {title: '异常确认处理', field: 'custComfirmException', sortable: true, width: 100,slots: {default: 'comfirmExceptionSlot'}},
        {title: '用户确认方式', field: 'custComfirmType', sortable: true, width: 100,slots: {default: 'comfirmTypeSlot'}},
        {title: '用户确认结果', field: 'custComfirmResult', sortable: true, width: 100,slots: {default: 'comfirmResultSlot'}},
        {title: '无法确认原因', field: 'custComfirmNotReason', sortable: true, width: 100,},
        {title: '现场人电话', field: 'custComfirmMobile', sortable: true, width: 100,},
        {title: '添加号码原因', field: 'custComfirmMobileReason', sortable: true, width: 100,},


        {title: this.$t('common.ContactPerson'), field: 'userName', sortable: true, width: 100,},
        {title: this.$t('common.contactNumber'), field: 'userMobile', sortable: true, width: 120,},
        {
          title: this.$t('common.district'), field: 'area', sortable: true, width: 180, slots: {
            default: ({row}) => {
              return [<span>{row.userProvice}{row.userCity}{row.userCounty}{row.userTown}</span>]
            }
          }
        },
        {title: this.$t('common.address'), field: 'userAddress', sortable: true, width: 160,},
        {title: this.$t('common.ServiceCenter'), field: 'orgName', sortable: true, width: 100,},
        {title: this.$t('common.BigServiceProvider'), field: 'bigSiteName', sortable: true, width: 100,},
        {title: this.$t('common.SecondaryServiceProvider'), field: 'siteName', sortable: true, width: 100,},
        {title: this.$t('common.Engineer'), field: 'engineerName', sortable: true, width: 100,},
        {title: this.$t('common.CreationTime'), field: 'createTime', sortable: true, width: 150,},
        {title: this.$t('common.ProductCategory'), field: 'bigCategoryName', sortable: true, width: 104,},
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    // ...mapState(['clickMenu']),

  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {

      if (newVal === 'second') {
        this.orderDealType=""
        if(this.editViewDataUpdateFlag) {
          this.getTableData()
        }
      }
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.bookDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.bookDateBegin = newVal[0]
          this.formData.bookDateEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.bookDateBegin = null
          this.formData.bookDateEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.soOrderExport = this.permissions["soOrderExport"]
    this.checkButton = this.permissions["checkButton"];
    this.exceptionDeal = this.permissions["exceptionDeal"];
    // this.reAssignmentSJ = this.permissions["reAssignment"];
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId){
      this.isSite = true;
    }
    console.log("是否为服务商"+this.isSite)
  },

  mounted() {
    // this.initSearchDate();
    this.loadbigCategoryOptions();
  },

  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    //加载产品大类
    loadbigCategoryOptions() {
      this.$http({
        url: api.basItemCategory.getBigItemCategory,
        method: 'get',
        params: {
          companyId : store.getters.userInfo.tenantId
        }
      }).then(res => {
        this.bigCategoryOption = res.data.data
        console.log("bigCategoryOption",this.bigCategoryOption)
      })
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 加载tab数据
    async loadTabOption() {
      await this.$http.post(api.soOrder.getCountUrl, this.requestParam).then(res => {
        this.goodsStatusList = res.data.data
        if (this.goodsStatusList && this.goodsStatusList.length > 0 && this.requestParam.tabStat == null) {
          this.requestParam.tabStat = this.goodsStatusList[0].name
        }
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      console.log('goodsStatusItem', this.goodsStatusItem)
      this.requestParam.tabStat = this.goodsStatusItem
      this.enableStat = item.name === '所有'

      this.getTableData()
    },

    // 加载table数据
    async getTableData() {

      await this.loadTabOption()
      this.requestParam.pageType = '异常确认处理'
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.soOrder.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },
    closeD(type){
      this.showCloseOrderDialog = type;
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },

    toFilterData() {
      // console.log(55,"触发了搜索");
      // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
      if (this.formData === '') {
        return
      } else {
        // 请求查询接口，将列表展现出来
        this.searchEvent();
      }
    },


    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleAreaChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
      console.log(row, id, "row");
    },

    // 操作下拉选
    handleCommand(type, row) {
      if (type ==1) {
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.showExceptionDealDialog = true;
      }
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
      this.activeName = 'second';
    },

    //重新转派
    reAssignment(row){
      this.$baseConfirm('您确定要重新转派工单吗？').then(() => {
        this.$http({
          url: api.soOrder.reAssignmentUrl,
          method: 'post',
          data: {
            id:this.orderId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          this.reload()// 需要刷新页面
        })
      });
    },

    closeExceptionOrderDeal(type){
      this.showExceptionDealDialog = false;
      if (type == 1){
        this.reload()// 需要刷新页面
      }
    },
    //取消审核回调方法
    doCancelCheck(type){
      this.showCancelCheckDialog = false;
      if (type == 1){
        this.reload()// 需要刷新页面
      }
    },

    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },

    // 新增
    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log(this.dataId, '触发了跳转');
    },

    initTableList() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.soOrder.getTableDataUrl,
        param: this.formData,
        method: 'post',


      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);

      this.$refs['table-m1'].commitProxy('reload');
    },

    //导出
    doExcle() {
      // const  result =
      this.$mask.open()
      this.$objCopy(this.formData, this.requestParam)
      console.log("工单导出传参this.requestParam:",this.requestParam)
      console.log("工单导出传参this.formData:",this.formData)
      doCheckExcle(fileNames.order).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.soOrder.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },


  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-select__tags > span{
  display: flex !important;;
}
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}


::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}


::v-deep .el-cascader--medium {

  height: 38px;
}

.icon_w {
  width: 7px;
}
</style>
